/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAppleIos = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m16.016 6.308.282.017a5.118 5.118 0 0 1 4.032 2.18 4.996 4.996 0 0 0-2.38 4.195 4.83 4.83 0 0 0 2.949 4.444 11.085 11.085 0 0 1-1.534 3.124c-.904 1.352-1.852 2.673-3.355 2.697-1.461.034-1.952-.86-3.628-.86-1.691 0-2.215.836-3.616.894-1.432.053-2.527-1.442-3.463-2.783-1.872-2.733-3.329-7.705-1.375-11.087a5.369 5.369 0 0 1 4.519-2.756c1.434-.03 2.764.967 3.645.967.865 0 2.51-1.193 4.206-1.015zm.3-5.308a4.925 4.925 0 0 1-1.127 3.527 4.14 4.14 0 0 1-3.27 1.546 4.689 4.689 0 0 1 1.156-3.396A5.011 5.011 0 0 1 16.315 1z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAppleIos as AppleIos };
